import * as React from 'react';
import moment from 'moment';

import { StreakDay } from '../../shared/api/api';
import { dayVariant } from '../../shared/helpers/streakFreeze';
import { addModifiers } from '../../shared/helpers';
import './StreakWeekStrip.scss';

interface StreakWeekStripProps {
  records: StreakDay[] | undefined;
}

// The Mon..Sun day row shared by StreakModal and StreakProtectedModal: a fire/inactive/snowflake
// icon per day with its weekday label. Keeps the markup, day-variant precedence, and SCSS in one
// place so the two modals can't drift.
export function StreakWeekStrip({ records }: StreakWeekStripProps) {
  return (
    <div className="streak-week-strip">
      {records?.map(day => (
        <div key={day.date} className="streak-week-strip__day">
          <div>
            <div className={addModifiers('streak-week-strip__icon', [dayVariant(day)])} />
          </div>
          <div>{moment(day.date).format('dd')}</div>
        </div>
      ))}
    </div>
  );
}
